import React, { useMemo, useState } from 'react';
import { MailPlus } from 'lucide-react';
import { authAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

const InviteCreateResource = () => {
  const { user } = useAuth();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const canCreate = useMemo(() => {
    const normalized = (user?.email || '').toLowerCase().trim();
    return normalized.endsWith('@hrfactory.com');
  }, [user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (!canCreate) {
      setError('Du hast keine Berechtigung, Einladungen zu erstellen.');
      return;
    }

    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) {
      setError('Bitte gib eine E-Mail-Adresse ein.');
      return;
    }

    try {
      setSubmitting(true);
      const { data } = await authAPI.inviteCreate(normalizedEmail);
      setSuccess(data?.detail || `Einladung an ${normalizedEmail} wurde gesendet.`);
      setEmail('');
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          'Einladung konnte nicht erstellt werden. Bitte später erneut versuchen.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-7">
        <h1 className="text-3xl font-bold text-gray-900">Einladung erstellen</h1>
        <div className="w-12 h-1 rounded-full mt-2 mb-3 bg-hrf-coral" />
        <p className="text-gray-500">
          Lade neue Nutzer zur Plattform ein. Die Person erhält automatisch eine E-Mail mit einem
          sicheren Einladungslink.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 md:p-7">
        <form onSubmit={handleSubmit} className="space-y-4">
          <label htmlFor="invite-email" className="block text-sm font-medium text-gray-700">
            E-Mail-Adresse der einzuladenden Person
          </label>
          <input
            id="invite-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@unternehmen.de"
            autoComplete="email"
            className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy transition-colors"
          />

          {error ? <p className="text-sm text-hrf-coral">{error}</p> : null}
          {success ? <p className="text-sm text-emerald-700">{success}</p> : null}

          <button
            type="submit"
            disabled={submitting || !canCreate}
            className="inline-flex items-center gap-2 rounded-lg bg-hrf-navy text-white text-sm font-semibold px-5 py-2.5 hover:bg-hrf-navy-800 transition-colors focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <MailPlus className="h-4 w-4" />
            {submitting ? 'Wird gesendet…' : 'Einladung senden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default InviteCreateResource;
